// extracted by mini-css-extract-plugin
export default {"summary-container":"ManufacturerReportSummary_summary-container__kyDmw","summary-ctas":"ManufacturerReportSummary_summary-ctas__dXB+S"};